<ion-item
  [button]="button"
  [detail]="detail"
  [disabled]="disabled"
  [class.disabled-item]="disabled"
>
  <ion-avatar slot="start" class="user-avatar">
    <div class="thumbnail-placeholder"></div>
  </ion-avatar>
  <ion-label>
    <h2>{{ getUserDisplayName(user) }}</h2>
    <p>{{ user.email }}</p>
  </ion-label>
  @if (disabled && disabledMessage) {
    <ion-badge slot="end" color="medium">{{ disabledMessage }}</ion-badge>
  }
</ion-item>
